import { AgGridDefaultFilterModel } from '@shared/utils/interfaces';
import { DoesFilterPassParams } from 'ag-grid-community';

export const doesDropdownFilterPass = (params: DoesFilterPassParams<any, any, AgGridDefaultFilterModel<unknown[]>>): boolean => {
  const { model, node, handlerParams } = params;

  if (!model?.filter?.length) {
    return true;
  }

  const cellValue = handlerParams.getValue(node);

  if (cellValue === null) {
    return false;
  }

  if (Array.isArray(cellValue)) {
    return model.filter.some((item) => cellValue.includes(item));
  }

  return model.filter.includes(cellValue);
};
